export default class ChatMessageCreation {
  public message: string;

  constructor(message: string) {
    this.message = message.trim();
  }
}
